import Swiper from 'swiper';
import { Navigation, Thumbs, A11y, EffectFade } from 'swiper/modules';

export function initDetailCardSwiper() {
    const containers = document.querySelectorAll('.detail-card__box-swiper');

    if (!containers.length) return;

    containers.forEach((container) => {
        if (!(container instanceof HTMLElement)) return;

        const mainEl = container.querySelector('.swiper-detail-card');
        const previewEl = container.querySelector('.swiper-preview-card');

        if (!(mainEl instanceof HTMLElement) || !(previewEl instanceof HTMLElement)) return;

        const prevBtn = container.querySelector('.--prev');
        const nextBtn = container.querySelector('.--next');

        // --- PREVIEW SLIDER ---
        const previewSwiper = new Swiper(previewEl, {
            modules: [Navigation, Thumbs, A11y],
            slidesPerView: 4,
            spaceBetween: 8,
            watchSlidesProgress: true,
            slideToClickedSlide: true,

            breakpoints: {
                992: {
                    spaceBetween: 12,
                },
            },

            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
        });

        // --- MAIN SLIDER ---
        new Swiper(mainEl, {
            modules: [Thumbs, A11y, EffectFade],
            slidesPerView: 1,
            spaceBetween: 10,
            speed: 600,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },

            thumbs: {
                swiper: previewSwiper,
            },
        });
    });
}